'use strict';

var typography = {};

exports.__exports = typography;
//# sourceMappingURL=typography6.cjs.map
